// src/pages/QuizPage/hooks/useQuizKeyboard.ts
import { useEffect } from "react";

interface UseQuizKeyboardOptions {
  finished: boolean;
  isMarafonMode: boolean;
  current: number;
  answered: Record<number, number>;
  questionsLength: number;
  handleAnswer: (orderIndex: number) => void;
  setCurrent: React.Dispatch<React.SetStateAction<number>>;
  displayChoices?: Array<{ order_index: number }>;
}

export function useQuizKeyboard({
  finished,
  isMarafonMode,
  current,
  answered,
  questionsLength,
  handleAnswer,
  setCurrent,
  displayChoices,
}: UseQuizKeyboardOptions) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (finished) return;

      // Input/textarea ichida bo'lsa — keyboard ishlamasin
      const target = e.target as HTMLElement | null;
      if (
        target &&
        (target.tagName === "INPUT" || target.tagName === "TEXTAREA")
      ) {
        return;
      }

      // F1-F5 → javob tanlash (faqat javob berilmagan bo'lsa)
      const fKeys = ["F1", "F2", "F3", "F4", "F5"];
      const fIdx = fKeys.indexOf(e.key);
      if (fIdx !== -1 && answered[current] === undefined) {
        e.preventDefault();
        // displayChoices uzatilgan bo'lsa — haqiqiy order_index ishlatiladi
        // (shuffle holati bilan mos keladi)
        const orderIndex =
          displayChoices?.[fIdx]?.order_index ?? fIdx + 1;
        handleAnswer(orderIndex);
        return;
      }

      // ArrowLeft — orqaga (marafon'da yo'q)
      if (e.key === "ArrowLeft" && !isMarafonMode) {
        setCurrent((p) => Math.max(0, p - 1));
        return;
      }

      // ArrowRight — keyingisi
      if (e.key === "ArrowRight") {
        // Marafon'da javob berilmagan bo'lsa, oldinga o'tib bo'lmaydi
        if (isMarafonMode && answered[current] === undefined) return;
        setCurrent((p) => Math.min(questionsLength - 1, p + 1));
        return;
      }
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [
    finished,
    isMarafonMode,
    current,
    answered,
    questionsLength,
    handleAnswer,
    setCurrent,
    displayChoices,
  ]);
}
